<div class="mainContainer mt-5 d-flex flex-column align-items-center">
  <div class="vMax wrap">
    <div class="heroWrap">
      <h2 class="headingWL">Cancellation <span> And Refund</span></h2>
    </div>

    <div class="wrapper">
      <div class="cardWrap" *ngFor="let item of data">
        <h3 class="headingBS">
          {{ item.name1 }} <span> {{ item.name2 }} </span>
        </h3>
        <p class="vtext1" *ngFor="let detail of item.details">{{detail}}</p>
      </div>
      <div class="cardWrap">
        <h6 *ngFor="let mDetails of moreDetails" > {{mDetails}} </h6>
      </div>
    </div>
  </div>
</div>